import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NbAuthService, NbAuthToken } from '@nebular/auth';
import { switchMap } from 'rxjs/operators';
import { EventListResponse } from '../models/event/event-list-response';
import { Constants } from '../models/constants.model';
import { Event } from '../models/event/event';
import { BaseClient } from './base-client.service';

@Injectable()
export class EventClient extends BaseClient {

    public static readonly BASE_ENDPOINT = Constants.API_BASE_URL + '/api/events';

    public list(): Observable<EventListResponse> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.get<EventListResponse>(EventClient.BASE_ENDPOINT, {headers: this.getHeaders(token)});
        }));
    }

    public show(id: string): Observable<Event> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.get<Event>(EventClient.BASE_ENDPOINT + '/' + id, {headers: this.getHeaders(token)});
        }));
    }

    public store(formData: FormData): Observable<Event> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.post<Event>(EventClient.BASE_ENDPOINT, formData, {headers: this.getHeaders(token, false)});
        }));
    }

    public update(id, formData: FormData): Observable<Event> {
        formData.append('_method', 'PUT');
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.post<Event>(EventClient.BASE_ENDPOINT + '/' + id, formData, {headers: this.getHeaders(token, false)});
        }));
    }

    public delete(id): Observable<any> {
        return this.authService.getToken().pipe(switchMap((token) => {
            return this.http.delete<any>(EventClient.BASE_ENDPOINT + '/' +  id, {headers: this.getHeaders(token)});
        }));
    }

}
